import React, { useState, useLayoutEffect } from "react";
import { FieldEntry } from "../../generic-components/FieldEntry";
import {
  Distance,
  parseDistance,
  isValidDistance
} from "../../pace-fns/pace-fns";
import { validateDistanceField, FieldChangeResult } from "./controlUtility";
import { isDistanceValid } from "../../calculator.utility";

const HelpTextDistance = "ie. valid format is 12 or 12.4";
const FieldName = "Distance";

export type DistanceFieldChangeResult = FieldChangeResult<{
  value: Distance | undefined;
}>;

type Props = {
  distance: Distance;
  onChange(change: DistanceFieldChangeResult): void;
};

export const DistanceControl = ({ distance, onChange }: Props) => {
  const [isValid, setIsValid] = useState(true);
  const [distanceValue, setDistanceValue] = useState(
    String(distance.units || "")
  );

  useLayoutEffect(() => {
    setDistanceValue((isDistanceValid(distance) && `${distance.units}`) || "");
  }, [distance]);

  const onFieldChange = (value: string) => {
    const valid = validateDistanceField(value);
    setIsValid(valid);
    const newDistance = parseDistance(value, distance.unitOfMeasure);
    onChange({
      data: { value: newDistance },
      valid: isValidDistance(newDistance)
    });
  };

  return (
    <FieldEntry
      fieldName={FieldName}
      value={distanceValue}
      onFieldChange={onFieldChange}
      isValid={isValid}
      onErrorText={HelpTextDistance}
    />
  );
};
